export const tenants = {
	arc: {
		logo: '/assets/tenants/arc/logo.svg',
		logoInverted: '/assets/tenants/arc/logo.svg',
		welcome: '/assets/tenants/arc/welcome.jpg',
		name:	'CDLX',
		productname: 'Werkverzeichnis',
		fullProductName: 'CDLX Werkverzeichnis',
		privacyUrl: 'https://cdlx.de',
	},
	aaki: {
		logo: '/assets/tenants/aaki/logo.svg',
		logoInverted: '/assets/tenants/aaki/logoInverted.svg',
		welcome: '/assets/tenants/aaki/welcome.jpg',
		name:	'AAKIO',
		productname: 'Werkverzeichnis',
		fullProductName: 'AAKIO Werkverzeichnis',
		privacyUrl: 'https://aakio.io/datenschutz',
	},
	kfn: {
		logo: '/assets/tenants/kfn/logo.svg',
		logoInverted: '/assets/tenants/kfn/logo.svg',
		welcome: '/assets/tenants/kfn/welcome.jpg',
		name:	'Stiftung Kunstfonds',
		productname: 'Werkverzeichnung',
		fullProductName: 'Stiftung Kunstfonds Werkverzeichnung',
		privacyUrl: 'https://www.kunstfonds.de/datenschutzerklaerung',
	},
	ksa: {
		logo: '/assets/tenants/ksa/logo.svg',
		logoInverted: '/assets/tenants/ksa/logo.svg',
		welcome: '/assets/tenants/ksa/welcome.jpg',
		name:	'Kunststiftung Sachsen-Anhalt',
		productname:	'Werkverzeichnis',
		fullProductName: 'Werkverzeichnis der Kunststiftung Sachsen-Anhalt',
		privacyUrl: 'https://www.kunststiftung-sachsen-anhalt.de/datenschutz/',
	},
};

export function getTenantData(tenant, field) {
	return tenants[tenant][field];
}
